import { Controller } from "stimulus"
import axios from 'axios';
import queryString from 'query-string';
export default class extends Controller {
  static get targets() {
    return ["boxtable", 'paginationLink', 'pageDisplay', "newBtn", "currentQuery"];
  }
  initialize(){ 
   this.setCurrentPage(parseInt(this.data.get('current-page')));
   this.search = _.throttle(this.search, 300);
   this.setCurrentQuery();
  }

  connect(){
   this.setActive();
  
  }

  setCurrentQuery(){
    let q = this.currentQueryTarget; 
    if (q.value !== ""){
      this.currentQuery =  this.buildInputsQuery(q);
       }
  }

  buildInputsQuery(input){
    let term = input.value; 
    let field = input.name; 
    let query = {}
    query[field] = term; 
    return query;
  }

  search(event){
    let input = event.target; 
    let query = this.buildInputsQuery(input); 
    
    this.goToPage(event, query);
  } 

  new(){
 
    let el = $('.empty-row').first().clone();
  
    $(el).prependTo('tbody');

    let element = document.querySelector('tr[data-controller="box"'); 
    element.setAttribute('data-box-id', "");
    element.classList.toggle('empty-row', false); 
  }

  goToPage(event, query={}){
  var page; 
  var currentQuery;
  let params = {}
  if (event !== undefined  && event.target.tagName !== 'INPUT'){   
    let query_obj = this.getPage(event.target);
    page = parseInt(query_obj.page); 
    this.currentQuery = {'name_contains': query_obj["q[name_contains]"]};
  }
  else {
    page = parseInt(this.currentPage);
   }

   if (Object.keys(query).length){
    params['q'] = query 
    page = 1 
    }
  else {
    params['page'] = page;
    
    if (this.currentQuery){
      params['q'] = this.currentQuery; 
    }
 
   }
    let t = this;
    axios.defaults.headers.common['Accept'] = 'application/json';
      axios.get('/rmrc_ad/box_manager', {params})
        .then(function(response){
          t.boxtableTarget.innerHTML = response.data;
          t.setCurrentPage(page);
        }).catch(function(err){
          //session expired most likely returning 406, reload page
          window.location.reload()
        })
   }

   getPage(el){
    return queryString.parse(el.getAttribute('data-box-manager-page'));
   }

   setActive(){

    this.paginationLinkTargets.forEach((el, i) => {
      el.classList.toggle("active", this.getPage(el) === this.currentPage);
    })
   }

   boxController(element) {

   
    return this.application.getControllerForElementAndIdentifier(element, "box");
  }

   setCurrentPage(page){
    this.currentPage = page; 
    this.pageDisplayTarget.innerHTML = page; 
   }
}


// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/box_manager_controller.js